import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { UploadService } from 'src/services/upload.service';
import { DialogComponent } from '../dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/services/dialog.service';

@Component({
  selector: 'app-drop-zone-image',
  templateUrl: './drop-zone-image.component.html',
  styleUrls: ['./drop-zone-image.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DropZoneImageComponent),
    multi: true
  }]
})
export class DropZoneImageComponent implements OnInit {
  @Input() preview: string | ArrayBuffer | null = null;
  isFullScreen: boolean = false;
  @Input() width: String = '100%';
  @Output() image = new EventEmitter<any>(); // อีเวนต์สำหรับการเปลี่ยนหน้า
  uploading = false;
  uploadProgress = 0;
  private _value: string | ArrayBuffer | null = null; // Store the current value

  constructor(
    private uploadService: UploadService,
    private dialogService: DialogService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
  }
  // ControlValueAccessor methods
  writeValue(value: any): void {
    this._value = value;
    this.preview = value; // Update the preview image when the form control value changes
  }

  registerOnChange(fn: any): void {
    this.onChange = fn; // Register the change handler
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn; // Register the touched handler
  }

  onChange: any = () => { };
  onTouched: any = () => { };

  // file upload

  // Method to handle the file selection event
  validateAndPreview(file: File) {
    this.uploadProgress = 0;

    // Check if the file is a valid Image file
    const validExtensions = ['png', 'jpg', 'jpeg', 'gif'];
    const fileExtension = file.name.split('.').pop();
    const fileName = file.name;
    const fileSize = file.size;
    const maxFileSize = 2 * 1024 * 1024;
    if (fileExtension && validExtensions.includes(fileExtension.toLowerCase())) {
      if (fileSize <= maxFileSize) {
        this.uploadProgress = 40;
        this.uploadImage(file);
      } else {
        console.error('File size exceeds 2MB. Please upload a smaller file.');
        this.handleError('File size exceeds 2MB. Please upload a smaller file.');
      }
    } else {
      console.error('Invalid file type. Please upload an Image file.');
      this.handleError('Invalid file type. Please upload an Image file.');
      // Optionally show an error message to the user
    }
  }

  inputFile(event: Event) {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.validateAndPreview(file);
    }
    input.value = '';
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    const dropZone = event.currentTarget as HTMLElement;
    dropZone.classList.add('dragover');
  }

  // Handle the file drop event
  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    const dropZone = event.currentTarget as HTMLElement;
    dropZone.classList.remove('dragover');

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.validateAndPreview(files[0]);
    }
  }

  // Remove dragover style on drag leave
  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    const dropZone = event.currentTarget as HTMLElement;
    dropZone.classList.remove('dragover');
  }

  removeImage(event: Event) {
    event.stopPropagation(); // หยุดการแพร่กระจายของเหตุการณ์คลิก
    this.preview = null;
    this.image.emit('');
  }

  //end file upload

  openFullScreen(event: Event) {
    event.stopPropagation(); // หยุดการแพร่กระจายของเหตุการณ์คลิก
    this.isFullScreen = true;
  }

  closeFullScreen() {
    this.isFullScreen = false;
  }


  uploadImage(file: File): void {
    this.uploading = true;
    const timestamp = new Date();
    const formattedDate = timestamp.toISOString().slice(0, 10).replace(/-/g, '');
    const formattedTime = timestamp.toTimeString().slice(0, 8).replace(/:/g, '');
    const fileExtension = file.name.split('.').pop(); // ดึงนามสกุลไฟล์
    const newFileName = `${formattedDate}_${formattedTime}.${fileExtension}`;

    const formData = new FormData();
    const renamedFile = new File([file], newFileName, { type: file.type });
    formData.append('file', renamedFile);

    this.preview = null;
    this.uploadProgress = 80;
    this.uploadService.uploadImageFiles(formData).subscribe({
      next: (res) => {
        this.uploadProgress = 100;
        this.uploading = false;
        const reader = new FileReader();
        reader.onload = () => {
          // Handle preview for multiple files here (perhaps store in an array)
          this.preview = res.url; // You can store multiple preview URLs in an array
        };
        this.uploadProgress = 0;
        reader.readAsDataURL(file);
        this.image.emit(res.url);
      },
      error: (error) => {
        this.handleError(error.error.message);
        this.uploadProgress = 0;
        this.uploading = false;
        // this.loading = false;
      },
    });
  }
  private handleError(message: string) {
    this.dialogService.openDialog({
      action: 'fail',
      title: 'unable_to_proceed',
      message: message
    }, () => null);
  }

  openDialog(data: any, callback: (data: boolean) => void): void {
    const dialogRef = this.dialog.open(DialogComponent, { width: '400px', data });
    dialogRef.afterClosed().subscribe(result => callback(result === 'confirm'));
  }
}
